import React from 'react';
import { useTheme } from 'pencil/styles';
import FeatureSearchIcon from 'mdi-react/FeatureSearchIcon';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import HistoryIcon from 'mdi-react/HistoryIcon';
import PackageVariantIcon from 'mdi-react/PackageVariantIcon';
import SteeringIcon from 'mdi-react/SteeringIcon';
import BookMultipleIcon from 'mdi-react/BookMultipleIcon';
import CreditCardMultipleIcon from 'mdi-react/CreditCardMultipleIcon';
import CropFreeIcon from 'mdi-react/CropFreeIcon';
import List from 'pencil/List';
import IconButton from 'pencil/IconButton';
import ChevronLeftIcon from 'pencil/icons/ChevronLeft';
import ChevronRightIcon from 'pencil/icons/ChevronRight';
import ListItem from 'pencil/ListItem';
import ListItemIcon from 'pencil/ListItemIcon';
import ListItemText from 'pencil/ListItemText';
import DashboardIcon from 'pencil/icons/Dashboard';
import LockIcon from 'pencil/icons/Lock';
import Typography from 'pencil/Typography';
import Box from 'pencil/Box';
import * as I18n from 'circe/I18n';
import FinancialSidebar from 'domain/finance/sidebar';
import ReconciliationSidebar from 'domain/finance/reconciliation/sidebar';
import DashboardOperationsSidebar from 'domain/operations/dashboard/sidebar';
import DashboardSidebar from 'domain/dashboard/Sidebar';
import BatchSidebar from 'domain/batch/sidebar';
import ShipmentsSidebar from 'domain/shipment/sidebar';
import SchedulerSidebar from 'domain/scheduler/sidebar';
import TripsSidebar from 'domain/trip/Sidebar';
import ShipmentsManagementSidebar from 'domain/shipmentsManagement/Sidebar';
import SettingsApplicationsIcon from 'pencil/icons/SettingsApplications';
import MapIcon from 'pencil/icons/Map';
import classNames from 'classnames';
import TimelineIcon from 'pencil/icons/Timeline';
import CompanyDialog from 'domain/fuse/preferences/code/CompanyDialog';
import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';
import { titleMapping } from 'domain/layout/constants';
import CarriersSidebar from 'domain/carriers/Sidebar';
import AccountAdminsSideBar from 'domain/accountAdmins/Sidebar';
import UsersSidebar from 'domain/fuse/auth/users/Sidebar';
import UploadIcon from 'mdi-react/UploadIcon';
import ProductIcon from 'domain/productType/components/Icon';
import VehiclesSidebar from 'domain/vehicle/Sidebar';

const ItemsSidebar = ({
  classes,
  sidebarTitle,
  isAllowedMenuItem,
  authorities,
  checkSidebarSelection,
  handleDrawerClose,
  toggleDrawer,
  isSidebarItemActive,
  open,
  currentPageTitle,
  setCurrentPageTitle,
  handleCompanyDialogOpen,
  companyDialogOpen,
  handleCompanyDialogClose,
  accountToken,
  isMobile,
}) => {
  const theme = useTheme();
  return (
    <>
      <div className={classes.drawerHeader}>
        <Typography variant="h6" className={classes.headerTitle} gutterBottom alignLeft>
          <Box fontWeight="bold">{sidebarTitle}</Box>
        </Typography>

        <IconButton
          onClick={handleDrawerClose}
          className={classNames({
            [classes.hide]: !open,
          })}
        >
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </div>

      {isAllowedMenuItem('PULSE', authorities)
        && checkSidebarSelection(I18n.str('dashboard', titleMapping.dashboard)) && (
          <>
            <div>
              <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                <Box fontWeight="bold">{I18n.str('general', 'General')}</Box>
              </Typography>
            </div>

            <List>
              <ItemNavLink
                classes={classes}
                titleMapping={titleMapping}
                toggleDrawer={toggleDrawer}
                isSidebarItemActive={isSidebarItemActive}
                open={open}
                toUrl="/dashboard"
                itemKey="pulse"
                iconComponent={<DashboardIcon />}
                groupTitle="dashboard"
              />
              <DashboardSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                key="dashboard"
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />
            </List>
          </>
      )}

      {isAllowedMenuItem('SHIPPING', authorities)
        && checkSidebarSelection(I18n.str('shipping', titleMapping.shipping)) && (
          <>
            {isAllowedMenuItem('MY_SHIPMENTS', authorities) && (
              <>
                <div>
                  <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                    <Box fontWeight="bold">
                      {I18n.str('shipmentsInformation', titleMapping.shipmentsInformation)}
                    </Box>
                  </Typography>
                </div>

                <BatchSidebar
                  isAllowedMenuItem={isAllowedMenuItem}
                  authorities={authorities}
                  classes={classes}
                  key="PatchSidebar"
                  toggleDrawer={toggleDrawer}
                  currentPageTitle={currentPageTitle}
                  setCurrentPageTitle={setCurrentPageTitle}
                  open={open}
                  isSidebarItemActive={isSidebarItemActive}
                  titleMapping={titleMapping}
                />
              </>
            )}

            {(isAllowedMenuItem('MY_SHIPMENTS', authorities)
              || isAllowedMenuItem('SUPPORT', authorities)) && (
              <ItemNavLink
                classes={classes}
                titleMapping={titleMapping}
                toggleDrawer={toggleDrawer}
                isSidebarItemActive={isSidebarItemActive}
                open={open}
                toUrl="/shipment/track"
                itemKey="shipmentHistory"
                iconComponent={(
                  <div>
                    <PackageVariantClosedIcon />

                    <HistoryIcon className={classes.smallIcon} size={16} />
                  </div>
                )}
                groupTitle="shipping"
              />
            )}

            {isAllowedMenuItem('USERS', authorities) && (
              <ItemNavLink
                classes={classes}
                titleMapping={titleMapping}
                toggleDrawer={toggleDrawer}
                isSidebarItemActive={isSidebarItemActive}
                open={open}
                toUrl="/factory-upload"
                itemKey="factoryFilesUpload"
                iconComponent={(
                  <div>
                    <UploadIcon />
                  </div>
                )}
                groupTitle="shipping"
              />
            )}

            {isAllowedMenuItem('ORDERS', authorities) && (
              <>
                <div>
                  <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                    <Box fontWeight="bold">
                      {I18n.str('shipmentsManagement', titleMapping.shipmentsManagement)}
                    </Box>
                  </Typography>
                </div>

                <List>
                  <ShipmentsManagementSidebar
                    isAllowedMenuItem={isAllowedMenuItem}
                    authorities={authorities}
                    classes={classes}
                    toggleDrawer={toggleDrawer}
                    currentPageTitle={currentPageTitle}
                    setCurrentPageTitle={setCurrentPageTitle}
                    open={open}
                    isSidebarItemActive={isSidebarItemActive}
                    titleMapping={titleMapping}
                  />
                </List>
              </>
            )}

            {isAllowedMenuItem('SHIPMENTS', authorities) && (
              <>
                <div>
                  <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                    <Box fontWeight="bold">
                      {I18n.str('shipmentsAdministration', titleMapping.shipmentsAdministration)}
                    </Box>
                  </Typography>
                </div>

                <List>
                  <ItemNavLink
                    classes={classes}
                    titleMapping={titleMapping}
                    toggleDrawer={toggleDrawer}
                    isSidebarItemActive={isSidebarItemActive}
                    open={open}
                    toUrl="/shipments"
                    itemKey="salesOrder"
                    iconComponent={<PackageVariantClosedIcon />}
                    groupTitle="shipping"
                  />
                  <SchedulerSidebar
                    isAllowedMenuItem={isAllowedMenuItem}
                    authorities={authorities}
                    classes={classes}
                    toggleDrawer={toggleDrawer}
                    currentPageTitle={currentPageTitle}
                    setCurrentPageTitle={setCurrentPageTitle}
                    open={open}
                    isSidebarItemActive={isSidebarItemActive}
                    titleMapping={titleMapping}
                  />
                </List>
              </>
            )}

            {isAllowedMenuItem('SHIPPERS', authorities) && (
              <>
                <div>
                  <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                    <Box fontWeight="bold">{I18n.str('shippers', titleMapping.shippers)}</Box>
                  </Typography>
                </div>

                <List>
                  <AccountAdminsSideBar
                    isAllowedMenuItem={isAllowedMenuItem}
                    authorities={authorities}
                    classes={classes}
                    toggleDrawer={toggleDrawer}
                    currentPageTitle={currentPageTitle}
                    setCurrentPageTitle={setCurrentPageTitle}
                    open={open}
                    isSidebarItemActive={isSidebarItemActive}
                    titleMapping={titleMapping}
                  />
                  <ItemNavLink
                    classes={classes}
                    titleMapping={titleMapping}
                    toggleDrawer={toggleDrawer}
                    isSidebarItemActive={isSidebarItemActive}
                    open={open}
                    toUrl="/shippers"
                    itemKey="shippers"
                    iconComponent={(
                      <div>
                        <AccountOutlineIcon />

                        <PackageVariantIcon size={16} className={classes.smallIcon} />
                      </div>
                    )}
                    groupTitle="shipping"
                  />
                </List>
              </>
            )}
          </>
      )}

      {checkSidebarSelection(I18n.str('finance', titleMapping.finance)) && (
        <>
          <div>
            <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
              <Box fontWeight="bold">{I18n.str('finance', titleMapping.finance)}</Box>
            </Typography>
          </div>

          <div>
            <List>
              <FinancialSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />
              <ReconciliationSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />
            </List>
          </div>
        </>
      )}
      {isAllowedMenuItem('DRIVERS', authorities)
        && checkSidebarSelection(I18n.str('drivers', titleMapping.drivers)) && (
          <>
            <div>
              <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
                <Box fontWeight="bold">{I18n.str('drivers', titleMapping.drivers)}</Box>
              </Typography>
            </div>

            <List>
              <CarriersSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />
              {isAllowedMenuItem('DRIVERS_PAGE', authorities) && (
                <ItemNavLink
                  classes={classes}
                  titleMapping={titleMapping}
                  toggleDrawer={toggleDrawer}
                  isSidebarItemActive={isSidebarItemActive}
                  open={open}
                  toUrl="/drivers"
                  itemKey="drivers"
                  iconComponent={(
                    <div>
                      <AccountOutlineIcon />

                      <SteeringIcon className={classes.smallIcon} size={16} />
                    </div>
                  )}
                  groupTitle="drivers"
                />
              )}
              <VehiclesSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />

              <TripsSidebar
                isAllowedMenuItem={isAllowedMenuItem}
                authorities={authorities}
                classes={classes}
                toggleDrawer={toggleDrawer}
                currentPageTitle={currentPageTitle}
                setCurrentPageTitle={setCurrentPageTitle}
                open={open}
                isSidebarItemActive={isSidebarItemActive}
                titleMapping={titleMapping}
              />
            </List>
          </>
      )}

      {checkSidebarSelection(I18n.str('settings', titleMapping.settings)) && (
        <>
          <div>
            <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
              <Box fontWeight="bold">{I18n.str('general', titleMapping.general)}</Box>
            </Typography>
          </div>

          <List>
            <UsersSidebar
              isAllowedMenuItem={isAllowedMenuItem}
              authorities={authorities}
              classes={classes}
              toggleDrawer={toggleDrawer}
              currentPageTitle={currentPageTitle}
              setCurrentPageTitle={setCurrentPageTitle}
              open={open}
              isSidebarItemActive={isSidebarItemActive}
              titleMapping={titleMapping}
            />
            <ItemNavLink
              classes={classes}
              titleMapping={titleMapping}
              toggleDrawer={toggleDrawer}
              isSidebarItemActive={isSidebarItemActive}
              open={open}
              toUrl="/address-book/query"
              itemKey="addresses"
              iconComponent={<BookMultipleIcon />}
              groupTitle="settings"
            />
            <ItemNavLink
              classes={classes}
              titleMapping={titleMapping}
              toggleDrawer={toggleDrawer}
              isSidebarItemActive={isSidebarItemActive}
              open={open}
              toUrl="/products"
              itemKey="productTypes"
              iconComponent={<ProductIcon />}
              groupTitle="settings"
            />
          </List>

          {companyDialogOpen && (
            <CompanyDialog
              open={companyDialogOpen}
              handlePopupClose={handleCompanyDialogClose}
              accountToken={accountToken}
            />
          )}

          <div>
            <Typography variant="h6" className={classes.subtitle} gutterBottom alignLeft>
              <Box fontWeight="bold">
                {I18n.str('planningSettings', titleMapping.planningSettings)}
              </Box>
            </Typography>
          </div>

          <List>
            <ItemNavLink
              classes={classes}
              titleMapping={titleMapping}
              toggleDrawer={toggleDrawer}
              isSidebarItemActive={isSidebarItemActive}
              open={open}
              toUrl="/settings"
              itemKey="planningSettings"
              iconComponent={<SettingsApplicationsIcon />}
              groupTitle="settings"
            />

            <ItemNavLink
              classes={classes}
              titleMapping={titleMapping}
              toggleDrawer={toggleDrawer}
              isSidebarItemActive={isSidebarItemActive}
              open={open}
              toUrl="/zones"
              itemKey="zones"
              iconComponent={<MapIcon />}
              groupTitle="settings"
            />
          </List>
        </>
      )}

      {isMobile && (
        <>
          <List>
            <a
              href={`${STATIC_FILES_URL}/privacypolicy.html`}
              className={classes.link}
              target="_blank"
              rel="noreferrer"
            >
              <ListItem button key="privacyPolicy">
                <ListItemIcon>
                  <LockIcon />
                </ListItemIcon>

                <ListItemText
                  classes={{ primary: classes.itemText }}
                  primary={I18n.str('privacyPolicy', 'Privacy Policy')}
                />
              </ListItem>
            </a>
          </List>
        </>
      )}
    </>
  );
};

export default ItemsSidebar;
